import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useActions } from '../redux/useActions';
import { getAuth as getAuthAction } from '../actions/authActions';


//high order wrapper component to fetch data from local storage / cookies / api on start up

export default function Master(props) {

    const authState = useSelector((state) => state.auth);
    
    const getAuth = useActions(() => getAuthAction);

    useEffect(() => {

        //check if user has an auth token already
        //if not, request one from the server as a guest
        async function checkForAuth() {
            if (!authState.authenticated) {
                await getAuth();
            }
        }

        checkForAuth();

      }, []);


    return (
        <>
            {props.children}
        </>
    )
}
